<template>
	<v-dialog v-model="dialog" max-width="500">
		<v-card>
			<v-toolbar dark color="primary" dense>
				<v-toolbar-title style="color: white"
					>権限の削除 | {{ user.last_name }} {{ user.first_name }}</v-toolbar-title
				>
				<v-spacer></v-spacer>
				<v-btn icon dark @click="dialog = false" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>
			<v-card-text class="pt-3">本当に削除しますか？</v-card-text>
			<v-card-actions>
				<v-btn
					color="green"
					text
					@click="
						deletePermittion()
						dialog = false
					"
					>はい</v-btn
				>
				<v-btn color="red" text @click="dialog = false">いいえ</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	data() {
		return {
			dialog: false,
			user: {},
			permission: {},
		}
	},
	methods: {
		confirmDelete(user, permission) {
			this.dialog = true
			this.user = user
			this.permission = permission
		},
		deletePermittion() {
			// 削除処理
			// deletePermittionという親コンポーネントのメソッドを呼び出す
			this.$emit("deletePermission", this.user, this.permission)
		},
	},
}
</script>
